import { render, staticRenderFns } from "./LoudMain.vue?vue&type=template&id=9a2d338a&scoped=true"
import script from "./LoudMain.vue?vue&type=script&lang=js"
export * from "./LoudMain.vue?vue&type=script&lang=js"
import style0 from "./LoudMain.vue?vue&type=style&index=0&id=9a2d338a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2d338a",
  null
  
)

export default component.exports